import { PictureSources } from '../photos-modal.types';

const SCROLL_END_THRESHOLD_PX = 48;
export const SCROLL_DEBOUNCE_MS = 100;

export const pictureThatIsSameAs = (picSource: PictureSources | null) => (pic: PictureSources) =>
  typeof picSource?.urlOriginal === 'string' && pic.urlOriginal === picSource.urlOriginal;

export const isScrolledNearEnd = (node: HTMLDivElement, atDesktop: boolean) =>
  atDesktop
    ? node.scrollTop + node.clientHeight >= node.scrollHeight - SCROLL_END_THRESHOLD_PX
    : node.scrollLeft + node.clientWidth >= node.scrollWidth - SCROLL_END_THRESHOLD_PX;

export const adjustScrollVertical = (
  containerRect: DOMRect,
  itemRect: DOMRect,
  containerScrollTop: number,
  scrollToCallback: (options: ScrollToOptions) => void,
) => {
  const itemSize = itemRect.width;
  const intersectionRatio = getIntersectionArea(containerRect, itemRect) / (itemSize * itemSize);

  if (intersectionRatio < 1) {
    const thmbBtm = itemRect.bottom;
    const cntrBtm = containerRect.bottom;
    const deltaY =
      thmbBtm > cntrBtm ? thmbBtm - cntrBtm + itemSize : itemRect.top - containerRect.top - itemSize / 2;

    scrollToCallback({
      top: containerScrollTop + deltaY,
      behavior: 'smooth',
    });
  }
};

export const adjustScrollHorizontal = (
  containerRect: DOMRect,
  itemRect: DOMRect,
  containerScrollLeft: number,
  scrollToCallback: (options: ScrollToOptions) => void,
) => {
  const itemSize = itemRect.height;
  const intersectionRatio = getIntersectionArea(containerRect, itemRect) / (itemSize * itemSize);

  if (intersectionRatio < 1) {
    const thmbRght = itemRect.right;
    const cntrRght = containerRect.right;
    const deltaX =
      thmbRght > cntrRght
        ? thmbRght - cntrRght + itemSize / 2
        : itemRect.left - containerRect.left - itemSize / 2;
    scrollToCallback({
      left: containerScrollLeft + deltaX,
      behavior: 'smooth',
    });
  }
};

export const getIntersectionArea = (rect1: DOMRect, rect2: DOMRect) => {
  const intersectionX1 = Math.max(rect1.left, rect2.left);
  const intersectionX2 = Math.min(rect1.left + rect1.width, rect2.x + rect2.width);
  if (intersectionX2 < intersectionX1) {
    return 0;
  }

  const intersectionY1 = Math.max(rect1.y, rect2.y);
  const intersectionY2 = Math.min(rect1.y + rect1.height, rect2.y + rect2.height);
  if (intersectionY2 < intersectionY1) {
    return 0;
  }

  const width = intersectionX2 - intersectionX1;
  const height = intersectionY2 - intersectionY1;

  return width * height;
};
